import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"

export const getWalletData = () => {
    return axiosPrivate.get(`/bills/api/v1/cashout-top-up/`)
}